import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Cardapio } from '../../providers/cardapio';
import { ProdutoPage } from '../produto/produto';

@Component({
  selector: 'page-ofertas',
  templateUrl: 'ofertas.html',
})
export class OfertasPage {

  items       : any = []
  loading     : boolean = false
  hasmore     : boolean = false
  defaultImage: any = "./assets/images/img-loading.png"
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public cardapioService: Cardapio) {
  }

  ionViewDidLoad() {
    this.loading = true;
    this.cardapioService.refresh();
    this.cardapioService.ofertas().then(
      data => {
        this.loading = false;
        this.items = data;
        this.hasmore = this.cardapioService.checkHasmore();
      }
    )
  }

  doRefresh(refresher) {
    this.cardapioService.refresh();
    this.cardapioService.ofertas().then(
      data => {
        refresher.complete();
        this.items = data;
        this.hasmore = this.cardapioService.checkHasmore();
      }
    )
  }

  doInfinite(infiniteScroll) {
    this.cardapioService.ofertas().then(
      data => {
        this.items = data;
        infiniteScroll.complete();
        this.hasmore = this.cardapioService.checkHasmore();
      }
    )
  }

  exibeProduto(item) {
    let info = { produto_categoria_nome: 'OFERTA' }
    this.navCtrl.push(ProdutoPage, { produto: item, categoria: info });
  }
}



// WEBPACK FOOTER //
// ./src/pages/ofertas/ofertas.ts